import {stateBase} from './index'
export default {
  // switchFn(state, parameter) {
  //   state.switch = parameter;
  // },
  queryItemsShowFn(state, parameter) {
    if(parameter&&parameter.reset){
      state.queryItemsShow=JSON.parse(JSON.stringify(stateBase.queryItemsShow));
    }else{
      Object.assign(state.queryItemsShow, parameter);
    }
  },
  queryDataFn(state, parameter) {
    if(parameter&&parameter.reset){
      state.queryData=JSON.parse(JSON.stringify(stateBase.queryData));
    }else{
      Object.assign(state.queryData, parameter);
    }
  },
  ajaxResponseFn(state, parameter) {
    if(parameter&&parameter.reset){
      state.ajaxResponse=JSON.parse(JSON.stringify(stateBase.ajaxResponse));
    }else{
      Object.assign(state.ajaxResponse, parameter);
    }
  },
  othersItemFn(state, parameter) {
    if(parameter&&parameter.reset){
      state.othersItem=JSON.parse(JSON.stringify(stateBase.othersItem));
    }else{
      Object.assign(state.othersItem, parameter);
    }
  },
  pageNum_Fn(state, parameter) {
    state.pageNum_ = parameter;
  },
  pageSize_Fn(state, parameter) {
    state.pageSize_ = parameter;
  },
  noResetFn(state, parameter) {
    if(parameter&&parameter.reset){
      // state.noReset=JSON.parse(JSON.stringify(stateBase.noReset));//不让重置,所以注释掉
    }else{
      Object.assign(state.noReset, parameter);
    }
  },
  queryBtnClickNumFn(state, parameter) {
    state.queryBtnClickNum = parameter;
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/query/mutations.js